// extracted by mini-css-extract-plugin
export default {"companyCardPage":"CompanyCardPage_companyCardPage__qdzSX","content":"CompanyCardPage_content__m3Eq6","leftBlock":"CompanyCardPage_leftBlock__Lk+CP"};